import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';

// The content of ./ProjectPages.tsx should move here when rewrite replaces old code
// For now the this file is being used to lazy load the new code to keep the bundle size small

const LazyProjectPages = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_project-pages-rewrite" */
			'./ProjectPages'
		),
);

export const ProjectPages = (props: any) => <LazyProjectPages {...props} />;
